export default "__VITE_ASSET__Cb$fXK4o__"